/* global APP_NAME */
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

import logoImage from "../../../static/image/cortex_nav_logo_blue.svg";
import { AppNav } from "./app-nav";
import { NavBar } from "./nav-bar";

class Header extends React.PureComponent {
  static get propTypes() {
    return {
      homepage: PropTypes.string,
    };
  }

  render() {
    return (
      <header className="main-header">
        <Logo homepage={this.props.homepage} />
        <NavBar>
          <AppNav />
        </NavBar>
      </header>
    );
  }
}

class Logo extends React.Component {
  static get displayName() {
    return "Header.Logo";
  }

  static get propTypes() {
    return {
      homepage: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      homepage: "/",
    };
  }

  render() {
    const appName = APP_NAME.toUpperCase();
    return (
      <Link to={this.props.homepage} className="logo">
        <img src={logoImage} alt={`CORTEX ${appName}`} />
        <span className="main">CORTEX</span>
        <span className="sub">{appName}</span>
      </Link>
    );
  }
}

module.exports = Header;
